const demoLogin = { 
    company_id: 0, 
    user_login: "demo", 
    user_pass: "demo"
  };

const optionValues = [
    { "value": -1, "label": "Nothing" },
    { "value": 0, "label": "Select" },
    { "value": 1, "label": "All" },
    { "value": 2, "label": "NA" },
    { "value": 3, "label": "General" },
    { "value": 4, "label": "None" },
    { "value": 5, "label": "Unavailable" },
    { "value": 6, "label": "Top" },
    { "value": 7, "label": "Blank" }
  ]

export const Fixture = {
  DemoLogin: demoLogin,
  OptionValues: optionValues,
}
  